import { fetchWithAuth } from '../lib/fetchWithAuth';

const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type JobMatchReason = {
  reason: string;
  score: number;
};

export type JobMatch = {
  id: string | number;
  title: string;
  company: string;
  location: string;
  salary?: string;
  type?: string;
  posted?: string;
  matchScore: number;
  matchReasons: JobMatchReason[];
  description: string;
  requirements: string[];
  benefits: string[];
  commute?: string;
  verified?: boolean;
  trending?: boolean;
};

export async function fetchJobMatches(): Promise<JobMatch[]> {
  if (!API_BASE_URL) {
    throw new Error('VITE_API_URL is required to fetch job matches.');
  }

  const response = await fetchWithAuth(`${API_BASE_URL}/v1/matches`);
  if (!response.ok) {
    throw new Error(`Job matches fetch failed (${response.status})`);
  }
  const payload = await response.json();
  if (Array.isArray(payload?.data)) {
    return payload.data as JobMatch[];
  }
  if (Array.isArray(payload)) {
    return payload as JobMatch[];
  }
  throw new Error('Job matches response malformed.');
}

export async function sendMatchFeedback(
  matchId: string | number,
  feedback: 'positive' | 'negative',
): Promise<{ success: boolean }> {
  if (!API_BASE_URL) {
    throw new Error('VITE_API_URL is required to send match feedback.');
  }

  const response = await fetchWithAuth(`${API_BASE_URL}/v1/matches/${matchId}/feedback`, {
    method: 'POST',
    body: JSON.stringify({ feedback }),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Match feedback failed (${response.status}): ${text}`);
  }

  return { success: true };
}
